import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'recaudacion/tipos-de-obras/';

/**
 * GET Tipos de Obras
 * @returns {Promise<Array<object>>}
 */
export const getTiposDeObras = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipo de Obra
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTipoDeObra = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Tipo de Obra
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeObra = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Obra
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeObra = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Obra
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTipoDeObra = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
